const TOKEN_KEY = 'account_repo_admin_token'
const USERNAME_KEY = 'account_repo_admin_username'
const EXPIRES_AT_KEY = 'account_repo_admin_expires_at'

function emitAuthChanged() {
  window.dispatchEvent(new Event('auth-changed'))
}

export function getAccessToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getAuthUsername() {
  return localStorage.getItem(USERNAME_KEY) || ''
}

export function getExpiresAt() {
  return localStorage.getItem(EXPIRES_AT_KEY) || ''
}

export function isLoggedIn() {
  return !!getAccessToken()
}

export function saveAuth(payload) {
  localStorage.setItem(TOKEN_KEY, payload.token || '')
  localStorage.setItem(USERNAME_KEY, payload.username || '')
  localStorage.setItem(EXPIRES_AT_KEY, payload.expires_at || '')
  emitAuthChanged()
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USERNAME_KEY)
  localStorage.removeItem(EXPIRES_AT_KEY)
  emitAuthChanged()
}

export function getAuthHeader() {
  const token = getAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
